// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"f4311956","88":"58854bee","172":"196e2153","204":"b83943cb","256":"3a9ef159","332":"c03cc439","376":"c52296c7","624":"739adb8d","650":"b8a358bf","712":"1b97c227","784":"89699962","952":"fcb1c35b"}[chunkId] + ".chunk.js";
};